module.exports = __webpack_public_path__ + "static/media/apartment5.813d94df.jpg";